export default __webpack_public_path__ + "d986c28595f45bdfeabe818b0fb00812.png";